const schema = localStorage.getItem("schema");
const currentDate = new Date();
export const basicFormData = () => ({
  inputData: {
    job_card_no: "",
    technician_id: "",
    assigned_by: "",
    technician_check_at: currentDate.toString(),
    technician_check_is_repairable: true,
    technician_check_remark: "",
    // material_id: "",
    // quantity: "",
    // available_quantity: "",
    component_reference_no_1: "",
    component_reference_no_2: "",
    component_reference_no_3: "",
    component_reference_no_4: "",
    component_reference_no_5: "",
    fault_reason_ids: "",
    scrap_reason_id: "",
    other_scrap_reason: "",
    created_by: "",
    updated_by: "",
    createdAt: "",
    updatedAt: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "job_cards",
    schema: schema,

    include: [
      {
        model: "user_masters",
        as: "technician",
      },
      {
        model: "user_masters",
        as: "assigned_by_user",
      },

      {
        model: "job_card_spare_lists",
        as: "spare_items",
        include: [
          {
            model: "material_masters",
            as: "material",
          },
        ],
      },
      {
        model: "material_intakes",
        as: "intake",
        include: [
          {
            model: "material_masters",
            as: "material",
          },
          {
            model: "branch_masters",
            as: "branch",
          },
          {
            model: "zone_masters",
            as: "zone",
          },
        ],
      },
    ],
    relation: [
      { model: "material_intakes", as: "intake" },
      { model: "user_masters", as: "technician" },
      { model: "user_masters", as: "assigned_by_user" },
      { model: "spare_part_requests", as: "spare_requests" },
    ],
  };

  const navigatePage = { back: "/job-card-list" };

  const headerName = "Job Card";

  const validationType = "JobCardCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "job_cards",
    schema: schema,
    include: [
      {
        model: "user_masters",
        as: "technician",
      },
      {
        model: "user_masters",
        as: "assigned_by_user",
      },
      {
        model: "job_card_spare_lists",
        as: "spare_items",
      },
      {
        model: "material_intakes",
        as: "intake",
        include: [
          {
            model: "material_masters",
            as: "material",
          },
        ],
      },
    ],
    relation: [
      { model: "material_intakes", as: "intake" },
      { model: "user_masters", as: "technician" },
      { model: "user_masters", as: "assigned_by_user" },
      { model: "spare_part_requests", as: "spare_requests" },
    ],
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "Job Card No", value: "job_card_no" },
    { label: "Intake No", value: "intake.intake_no" },
    { label: "Engineer", value: "technician_full_name" },
    { label: "Assigned By", value: "assigned_by_full_name" },
    // { label: "Engineer Check", value: "technician_check_at" },

    // {
    //   label: "Engineer Check Is Repairable",
    //   value: "technician_check_is_repairable",
    // },
    // { label: "Engineer Check Remark", value: "technician_check_remark" },
    { label: "Status", value: "status" },
    { label: "Is Active", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/job-card-create",
    edit: "/job-card-create",
    view: "/job-card-view",
  };

  const searchfields = [
    "job_card_no",
    "intake.intake_no",
    "intake.material_serial_no",
    "technician.first_name",
    "technician.last_name",
    "intake.material.gmds_code",
    "assigned_by_user.first_name",
    "assigned_by_user.last_name",
    "technician_check_at",
    "technician_check_remark",
    "status",
  ];
  const headerName = "Job Card";
  const endpoint = "/getRecords";
  const exportFileName = "JobCardData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "job_cards",
  schema: schema,
  include: [
    {
      model: "user_masters",
      as: "technician",
    },
    {
      model: "user_masters",
      as: "assigned_by_user",
    },
    {
      model: "job_card_spare_lists",
      as: "spare_items",
    },
  ],
  relation: [
    { model: "material_intakes", as: "intake" },
    { model: "user_masters", as: "technician" },
    { model: "user_masters", as: "assigned_by_user" },
    { model: "spare_part_requests", as: "spare_requests" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
